const estimateDictionary = new Map();
estimateDictionary.set("m", 0);
estimateDictionary.set("h", 1);
estimateDictionary.set("d", 2);
estimateDictionary.set("w", 3);

export const stringComparator = (value1, value2, sign) => {
    if (value1 == null) {
        throw "String comparator error. value 1 undefined."
    }
    if (value2 == null) {
        throw "String comparator error. value 2 undefined."
    }
    if (sign == null) {
        throw "String comparator error. sign undefined."
    }

    if (value1 === "n/a") {
        return 1 * sign;
    }
    if (value2 === "n/a") {
        return -1 * sign;
    }
    return (value1.toString().toLocaleLowerCase() === value2.toString().toLocaleLowerCase() ? 0 : (value1.toString().toLocaleLowerCase() > value2.toString().toLocaleLowerCase() ? 1 : -1)) * sign;
};
export const numberComparator = (value1, value2, sign) => {
    if (value1 == null) {
        throw "Number comparator error.value 1 undefined."
    }
    if (value2 == null) {
        throw "Number comparator error.value 2 undefined."
    }
    if (sign == null) {
        throw "Number comparator error.sign undefined."
    }
    if (isNaN(value1)) {
        return 1 * sign;
    }
    if (isNaN(value2)) {
        return -1 * sign;
    }
    return value1 === value2 ? 0 : (Number(value1) > Number(value2) ? 1 : -1) * sign;
};
export const dateComparator = (value1, value2, sign) => {
    if (value1 == null) {
        throw "Date comparator error.value 1 undefined."
    }
    if (value2 == null) {
        throw "Date comparator error.value 2 undefined."
    }
    if (sign == null) {
        throw "Date comparator error.sign undefined."
    }
    if (new Date(value1) === "Invalid Date") {
        return 1 * sign;
    }
    if (new Date(value2) === "Invalid Date") {
        return -1 * sign;
    }
    let val1 = new Date(value1).getTime(), val2 = new Date(value2).getTime();
    return val1 === val2 ? 0 : (val1 > val2 ? 1 : -1) * sign;
};

export const periodComparator = (value1, value2, sign) => {
    if (value1 == null || value1[0] == null) {
        throw "Period comparator error.value 1 undefined."
    }
    if (value2 == null || value2[0] == null) {
        throw "Period comparator error.value 2 undefined."
    }
    if (sign == null) {
        throw "Period comparator error.sign undefined."
    }
    if (value1[0] === "n/a" && value2[0] === "n/a") {
        return 0;
    } else if (value1[0] !== "n/a" && value2[0] !== "n/a") {
        let minLength = Math.min(value1.length, value2.length);
        for (let j = 0; j < minLength; j++) {
            let val1 = value1[j].replace(/\D/g, '');
            let val2 = value2[j].replace(/\D/g, '');
            let val1Chart = value1[j].replace(/[^a-zA-Z]+/g, '');
            let val2Chart = value2[j].replace(/[^a-zA-Z]+/g, '');
            if (estimateDictionary.get(val1Chart) === estimateDictionary.get(val2Chart)) {
                if (val1 === val2) {
                    if (j + 1 < minLength) {
                        continue;
                    } else {
                        if (value1[j + 1]) {
                            return 1 * sign;
                        }
                        if (value2[j + 1]) {
                            return -1 * sign;
                        }
                    }
                }
                return val1 === val2 ? 0 : (val1 > val2 ? 1 : -1) * sign;
            }
            if (estimateDictionary.get(val1Chart) > estimateDictionary.get(val2Chart)) {
                return 1 * sign;
            }
            if (estimateDictionary.get(val1Chart) < estimateDictionary.get(val2Chart)) {
                return -1 * sign;
            }
        }
    } else {
        if (value1[0] !== "n/a") {
            return -1;
        } else {
            return 1;
        }
    }
};


// WEBPACK FOOTER //
// ./app/components/bo-core/common/slickGridComparators.js